export * from '@styles/design-tokens/Output/numbers.enums';
export var Height;
(function (Height) {
    Height["XXS"] = "height-xxs";
    Height["XS"] = "height-xs";
    Height["SM"] = "height-sm";
    Height["MD"] = "height-md";
})(Height || (Height = {}));
export var Size;
(function (Size) {
    Size["XXS"] = "size-xxs";
    Size["XS"] = "size-xs";
    Size["SM"] = "size-sm";
    Size["MD"] = "size-md";
})(Size || (Size = {}));
